<template>
    <div>
        <v-container>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col  class="blue lighten-2 font-weight-bold">Vendor</v-col>
                        <template v-if="penawaran">
                            <v-col class="blue lighten-2 font-weight-bold">File Penawaran</v-col>
                        </template>
                        <template v-else>
                            <v-col v-if="kualifikasi" class="blue lighten-2 font-weight-bold">File Kualifikasi</v-col>
                            <v-col v-if="administrasi" class="blue lighten-2 font-weight-bold">File Administrasi</v-col>
                            <v-col v-if="teknis" class="blue lighten-2 font-weight-bold">File Teknis</v-col>
                            <v-col v-if="harga" class="blue lighten-2 font-weight-bold">File Harga</v-col>
                        </template>
                    </v-row>

                    <v-divider />

                    <v-row v-for="item in listPenawaran" :key="item.id">
                        <v-col> {{ item.nama }} </v-col>

                        <!-- FILE SATU PENAWARAN -->
                        <template v-if="penawaran">
                            <v-col>
                                <v-btn v-if="item.fileHarga !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FilePenawaran', item.fileHarga, item.vendorId)"><v-icon>get_app</v-icon></v-btn>
                                {{ item.fileHarga }} 
                            </v-col>
                        </template>

                        <template v-else>
                            <!-- FILE KUALIFIKASI -->
                            <v-col v-if="kualifikasi"> 
                                <v-btn v-if="item.fileKualifikasi !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileKualifikasi', item.fileKualifikasi, item.vendorId)"><v-icon>get_app</v-icon></v-btn>
                                {{ item.fileKualifikasi }} 
                            </v-col>

                            <!-- FILE ADMINISTRASI -->
                            <v-col v-if="administrasi"> 
                                <v-btn v-if="item.fileAdministrasi !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileAdministrasi', item.fileAdministrasi, item.vendorId)"><v-icon>get_app</v-icon></v-btn>
                                {{ item.fileAdministrasi }} 
                            </v-col>

                            <!-- FILE TEKNIS -->
                            <v-col v-if="teknis"> 
                                <v-btn v-if="item.fileTeknis !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileTeknis', item.fileTeknis, item.vendorId)"><v-icon>get_app</v-icon></v-btn>
                                {{ item.fileTeknis }} 
                            </v-col>

                            <!-- FILE HARGA -->
                            <v-col v-if="harga"> 
                                <v-btn v-if="item.fileHarga !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileHarga', item.fileHarga, item.vendorId)"><v-icon>get_app</v-icon></v-btn>
                                {{ item.fileHarga }} 
                            </v-col>
                        </template>

                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>


<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { TenderLib } from "./../../lib/tenderLib"


export default {
    props: {
        penawaran: {
            type: Boolean,
            default: false
        },
        kualifikasi: {
            type: Boolean,
            default: false
        },
        administrasi: {
            type: Boolean,
            default: false
        },
        teknis: {
            type: Boolean,
            default: false
        },
        harga: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            tenderLib: TenderLib,
            listPenawaran: [],
        }
    },

    computed: {
        paket() {
            return this.$store.getters['lelang/paket']
        },
    },

    watch: {
        paket() {
            this.getData();
        }
    },

    mounted() {
        this.getData()
    },

    methods: {
        getData() {
            this.listPenawaran = [];

            axios.get(`${apiUrl}/api/lelang/penawaran/${this.paket.id}`)
            .then( (response) => { 
                this.listPenawaran = response.data; 
            })
            .catch( (error) => { 
                console.error(error); 
            });
        },
    }
}
</script>


<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>
